function getCoordinateTypeForType(type) {
  return `attr.coordinate.${type}`;
}
function getAttributesForPie(attrs) {
  return attrs.filter(attr => attr.valueType !== 'timestamp').map(attr => {
    return {
      name: attr.displayName.replace('&#x2F;', ' - '),
      create: () => {
        return {
          objectType: attr.objectType,
          valueType: attr.valueType,
          name: attr.displayName,
          attrName: attr.name
        };
      }
    };
  });
}
export default {
  getCoordinateTypeForType,
  getAttributesForPie
};